import { patientService } from '@finpay-development/shared-platform/lib/esm/patient/services/patient-service';
import { setSelectedEncounter } from '@finpay-development/shared-platform/lib/esm/patient/state/patient-slice';
import { AppDispatch } from '../../../../../shared/state/store';

export async function syncIocFacilityAfterVobSave(
    dispatch: AppDispatch,
    patientEncounterId: number,
    facilityId: number
): Promise<{ success: boolean; errorMessage?: string }> {
    const response = await patientService.saveIOCWithPartialObject(
        { facilityId },
        patientEncounterId
    );

    if (response.hasErrors) {
        return {
            success: false,
            errorMessage: response.errorMessage || 'Failed to update IOC facility',
        };
    }

    if (response.entity) {
        dispatch(setSelectedEncounter(response.entity));
    }

    return { success: true };
}